import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "fixed bottom-0 w-full flex flex-col items-end pointer-events-none z-50"
};
const _hoisted_2 = {
  key: 0,
  class: "relative h-20 w-full flex items-center justify-center gap-4 shrink-0 px-2 before:absolute before:inset-0 before:bg-pro_dark before:-z-10 before:opacity-95 pointer-events-auto"
};
const _hoisted_3 = {
  class: "flex items-center gap-6 text-white text-base"
};
const _hoisted_4 = ["innerHTML"];
export function render(_ctx, _cache) {
  const _component_Button = _resolveComponent("Button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.$state.ui.subscriptionBanner ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("p", {
    class: "max-md:hidden",
    innerHTML: _ctx.$st('banners.insufficient-slans.banner')
  }, null, 8, _hoisted_4), _createVNode(_component_Button, {
    size: "lg",
    variant: "slango_pro",
    text: _ctx.$st('banners.insufficient-slans.button'),
    onClick: _cache[0] || (_cache[0] = $event => {
      _ctx.$router.push({
        name: 'Payments'
      });
      _ctx.$state.ui.subscriptionBanner = false;
    })
  }, null, 8, ["text"])]), _createElementVNode("i", {
    class: "icon-cross-rounded lg:absolute right-20 text-3xl fill-white cursor-pointer",
    onClick: _cache[1] || (_cache[1] = $event => _ctx.$state.ui.subscriptionBanner = false)
  })])) : _createCommentVNode("", true)]);
}